import React, {Component} from 'react';
import {  Link } from 'react-router-dom';
import axios from 'axios';
// const querystring = require('querystring');
export default class ManageArticle extends Component {

	constructor(props)
	{
		console.log(props);
		super(props);
				let parms = "";
// 				JSON.stringify(querystring.parse(this.props.location.search)).replace('?', '');
        console.log("parms => " + parms);

		this.state={
			blog : {
					"blogId": JSON.parse(parms).id,
				  "topic": "",
				  "fullText" : "",
				  "contentId" : 0,
				  "contentList" : "",
				  "contextId" : "",
				  "createUser": 0,
				  "createDate": new Date(),
				  "lastUpdateUser": 0,
				  "lastUpdateDate": new Date()
				  }
		}
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleOnLoad = this.handleOnLoad.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
	}
	handleChange(event) {
		console.log(event);
		var target = event.target;
		console.log(target.id + ":" + target.value);
		this.setState({
			[target.id] : target.value
		});
	   
		console.log(this.state);
	  }
	handleSubmit(event) {

		event.preventDefault();
		console.log('handling submit');  
	
	  	var url = `${global.config.apiServicesUrl}/blogs/${this.state.blog.blogId}`;

	  	this.setState({blog : {...this.state.blog, lastUpdateUser : Number(this.props.userId)}});

		axios.put(url, this.state.blog)
			.then(response2 => {
			
				console.log("response.data");
				console.log(response2.status +":"+response2.data.blogId);
				if (response2.status === 200 )
				{
					this.message = "Success";
				}
				else
				{
					 this.message = "Failed";
				}        
				console.log(this.message);
				event.preventDefault();
		  	}).catch(err => {
			 	console.log("error - " + err);
		});
		
		console.log("message info - " + this.message); 
		this.handleClear();		
		
		console.log("SetState Message info-"+this.contentFacadeTypeId);
		console.log("SetState Message info-"+this.contentFacadeName);
			
	 };
	 handleClear(){
		 this.setState({article : {}})
	 }
	 componentDidMount() 
	 {
	 	this.handleOnLoad();
	 }

	handleOnLoad = () => {
      axios.get(`${global.config.apiServicesUrl}/blogs/${this.state.blog.blogId}`).then(res => {

	      	this.setState({ blog : res.data });
    	  	console.log(res.data[0]);
      	
      		//resolve user names			
				 {
					axios.get(`${global.config.securityServicesUrl}/user-profile-service/userprofile/username/${this.state.blog.createUserId}`)
					.then(response =>{
 					this.setState({createUserName : response.data});
					}).catch(function (error) {
						console.log("Error:"+error);
					});		
					axios.get(`${global.config.securityServicesUrl}/user-profile-service/userprofile/username/${this.state.blog.lastUpdateUserId}`)
					.then(response =>{
 					this.setState({lastUpdateUserName : response.data});
					}).catch(function (error) {
					console.log("Error:"+error);
					});		
				}
		})
		.catch(function (error){
		})
	 }
	 handleDelete(event){
	 	event.preventDefault();
 	 	//alert(`deleting posting with id = ${this.state.blog.blogId}`);
		axios.delete(`${global.config.apiServicesUrl}/blogs/${this.state.blog.blogId}`).then(res => {
  		this.handleClear();
		window.location.href = "/articles";
  		});
	}
	
	render(){
    return (
        				<div class="m-content">				
			<div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
       				<div class="m-grid__item m-grid__item--fluid m-wrapper">
					<div class="m-subheader ">					
						<div class="d-flex align-items-center">
							<div class="mr-auto">
								<h3 class="m-subheader__title m-subheader__title--separator">Gazelle VLM</h3>
								<ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
									<li class="m-nav__item m-nav__item--home">
										<Link to="/" class="m-nav__link m-nav__link--icon">
											<i class="m-nav__link-icon la la-home"></i>
										</Link>
									</li>
									<li class="m-nav__separator">-</li>
									<li class="m-nav__item">
										<Link to="/" class="m-nav__link">
											<span class="m-nav__link-text">Home</span>
										</Link>
									</li>
								</ul>
							</div>
							<div>
								<span class="m-subheader__daterange" id="m_dashboard_daterangepicker">
									<span class="m-subheader__daterange-label">
										<span class="m-subheader__daterange-title"></span>
										<span class="m-subheader__daterange-date m--font-brand"></span>
									</span>
									<a href="#" class="btn btn-sm btn-brand m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill">
										<i class="la la-angle-down"></i>
									</a>
								</span>
							</div>
						</div>
						<br />

					<div className="content-wrapper">
		
		<form>
		<div class="container-fluid">
		<h4>Manage Article</h4>
		<hr />
		

		<div class="form-group row" >
		<label class="ContentTitle col-sm-2" >Topic</label>
		<input id="articleName" class="form-control input-medium col-sm-8" value={this.state.blog.topic} onChange ={this.handleChange}/>
		</div>
			<div class="form-group row" >
		<label class="ContentTitle col-sm-2" >Article</label>
		<textArea id="ownerUserId" class="form-control input-medium col-sm-8" rows="18" onChange ={this.handleChange}>
			{this.state.blog.fullText}
		</textArea>
		</div>

				<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Attachments</label>
			<select id="articleAttachments" class="form-control input-medium col-sm-8" value={this.state.blog.articleAttachments} onChange ={this.handleChange}/>
			</div>
		<hr />
		<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Post To Twitter</label>
			<input type="checkbox" value="Twitter" ></input>&nbsp;&nbsp;
		</div>

		<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Post To LinkedIn</label>
			<input type="checkbox" value="LinkedIn" />&nbsp;&nbsp;
		</div>

		<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Post To Facebook</label>
			<input type="checkbox" value="Facebook" />&nbsp;&nbsp;
		</div>

		<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Post To Instagram</label>
			<input type="checkbox" value="Instagram" />
		</div>

		
		<hr/>
		<div class="form-group row" >
		<label class="ContentTitle col-sm-2" >Created By</label>
		<input id="createUserName" class="form-control input-medium col-sm-2" value={this.state.createUserName} />
		<label class="ContentTitle col-sm-1" > On </label>
		<input id="createDate" class="form-control input-medium col-sm-2" value={String(this.state.blog.createDate).substring(0,10)} />
		</div>
		<div class="form-group row" >
		<label class="ContentTitle col-sm-2" >Last Updated By</label>
		<input id="lastUpdateUserName" class="form-control input-medium col-sm-2" value={this.state.lastUpdateUserName} />
		<label class="ContentTitle col-sm-1" > On </label>
		<input id="lastUpdateDate" class="form-control input-medium col-sm-2" value={String(this.state.blog.lastUpdateDate).substring(0,10)} />
		</div>
		<hr />	
					
					<button class="btn btn-primary" value="Clear" onClick ={this.handleClear}>Clear</button> &nbsp;
					<button class="btn btn-success" value="Save" onClick ={this.handleSubmit}>Save</button>&nbsp;
					<button class="btn btn-danger" value="Delete" onClick ={this.handleDelete}>Delete</button> 
		</div>		
		</form>
						</div>		

	            </div>	
            </div>
            
			</div>
			</div>
	);
}
}